import React, { useState } from 'react';
import { timeToClosedToast } from '../commons/values';
import { ModalSessionExpired } from '../commons/generics/ModalSessionExpired';
import MultipleSnackbars from '../commons/generics/MultipleSnackbars';
import { SnackAlert } from '../commons/generics/SnackAlert';
import { validateResponse } from '../commons/utils';

/**
 * Hook personalizado para centralizar la lógica de manejo de respuestas de la API,
 * alertas (Snackbars) y sesión expirada.
 *  
 * @returns {object} Un objeto con los handlers para validateResponse y el componente de UI.
 */
export const useResponseHandler = () => {
    const [modalSessionExpired, setModalSessionExpired] = useState<boolean>(false);
    const [timeAlert, setTimeAlert] = useState(timeToClosedToast);
    const [alert_snack, setAlertSnack] = useState(false);
    const [messagesAlerts, setMessagesAlerts] = useState<any>([]);
    const [msgSnack, setMsgSnack] = useState({
        msg: '',
        status: 'success'
    });

    /**
     * Handlers configurados para ser pasados a la función validateResponse.
     */
    const handlers = React.useMemo(() => ({
        setMsgSnack,
        setAlertSnack,
        setModalSessionExpired,
        setMessagesAlerts,
    }), []);

    /**
     * Procesa la respuesta de una thunk/API usando validateResponse.
     */
    const handleResponse = async (response: any, actionText: string, showSuccess = true) => {
        return await validateResponse(response, actionText, handlers, showSuccess);
    };

    /**
     * Componente que renderiza todas las alertas y modales necesarios.
     * Debe incluirse en el JSX del componente que usa el hook.
     */
    const ResponseComponents = (
        <>
            <ModalSessionExpired open={modalSessionExpired} />
            <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
            <SnackAlert 
                open={alert_snack} 
                onclick={setAlertSnack} 
                text={msgSnack.msg} 
                severity={msgSnack.status as any} 
            />
        </>
    );

    return {
        handlers,
        handleResponse,
        ResponseComponents,
        setMessagesAlerts,
        setTimeAlert,
        setMsgSnack,
        setAlertSnack,
        setModalSessionExpired
    };
};
